import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { ModalContentWhats } from "./components/ModalContentWhats";
import Button from "@mui/material/Button/Button";
import { useServiceWhatsApp } from "hooks/servicioWhastApp/useWhatsApp";
import { useEffect } from "react";

export const ModalWhats = () => {
  const { user, startGetStatusService, isModalOpen, closeModal } =
    useServiceWhatsApp();

  useEffect(() => {
    if (user && user.session) {
      startGetStatusService();
    } // eslint-disable-next-line
  }, [user]);

  return (
    <Dialog
      open={isModalOpen}
      fullWidth={true}
      maxWidth="md"
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      scroll="paper"
    >
      <DialogTitle>Mensajeria Instantanea via Whatsapp</DialogTitle>
      <DialogContent>
        <ModalContentWhats />
      </DialogContent>
      <DialogActions>
        <Button variant="contained" color="error" onClick={() => closeModal()}>
          Cerrar
        </Button>
      </DialogActions>
    </Dialog>
  );
};
